import { Maybe } from 'types/graphqlTypes'

export const getAwardedLaneWeight = ({
  maxWeight,
  minWeight,
}: {
  minWeight: Maybe<number>
  maxWeight: Maybe<number>
}) => {
  let formattedWeight = maxWeight ? `${maxWeight} lbs` : null
  if (formattedWeight && minWeight) {
    formattedWeight = `${minWeight} lbs - ${formattedWeight}`
  }

  return formattedWeight
}
